import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthStore } from '../services/auth.store';

export const ownerGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isOwner()) {
    return true;
  }

  if (authStore.isLoggedIn() && !authStore.loaded()) {
    return authStore.bootstrapSession(true).pipe(
      map(() => (authStore.isOwner() ? true : router.createUrlTree(['/404']))),
    );
  }

  return router.createUrlTree(['/404']);
};
